<svg
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M18.5637 12.7217C18.059 14.3693 17.0475 15.8158 15.6731 16.8553C14.4664 17.7634 13.0305 18.3173 11.5265 18.4548C10.0226 18.5922 8.51006 18.3077 7.15878 17.6333C5.80749 16.9589 4.67092 15.9212 3.87663 14.6367C3.08234 13.3522 2.66178 11.8718 2.66215 10.3615C2.65672 8.59874 3.22977 6.88287 4.2934 5.47714C5.33288 4.10276 6.77936 3.09124 8.42699 2.58651C8.53558 2.55308 8.65124 2.54987 8.76151 2.57725C8.87179 2.60463 8.97251 2.66155 9.05286 2.7419C9.1332 2.82224 9.19012 2.92297 9.2175 3.03324C9.24488 3.14352 9.24168 3.25917 9.20824 3.36776C8.84796 4.5595 8.81775 5.82666 9.12084 7.03422C9.42392 8.24178 10.0489 9.34448 10.9293 10.2248C11.8096 11.1052 12.9124 11.7302 14.1199 12.0333C15.3275 12.3364 16.5946 12.3062 17.7864 11.9459C17.895 11.9125 18.0106 11.9092 18.1209 11.9366C18.2312 11.964 18.3319 12.0209 18.4122 12.1013C18.4926 12.1816 18.5495 12.2823 18.5769 12.3926C18.6043 12.5029 18.6011 12.6185 18.5676 12.7271L18.5637 12.7217Z"
    fill="currentColor"
  />
</svg>
